export const getIconUrl = (icon: string): string => {
    return `/icons/${icon}`;
}

export const getImageUrl = (image: string): string => {
    return `/images/${image}`;
}